import {
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  useDisclosure,
} from "@heroui/modal";
import { Button, Image } from "@heroui/react";
import { FaSafari } from "react-icons/fa";
import { GoShare } from "react-icons/go";
import { BsPlusSquare } from "react-icons/bs";
import { Constants } from "~/lib/constants";
import { useEffect, useState } from "react";

export const MobileiOSBanner = ({
  setShowPWAInstallPrompt,
  isSafari,
}: {
  setShowPWAInstallPrompt: (value: boolean) => void;
  isSafari: boolean;
}) => {
  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const [linkCopied, setLinkCopied] = useState(false);

  useEffect(() => {
    if (linkCopied) {
      setTimeout(() => {
        setLinkCopied(false);
      }, 3000);
    }
  }, [linkCopied]);

  useEffect(() => {
    const url = new URL(window.location.href);
    const showInstallPrompt = url.searchParams.get(
      Constants.PWA.SHOW_IOS_INSTALL_PROMPT_MODEL_QUERY_PARAM
    );
    if (showInstallPrompt) {
      onOpen();
    }
  }, [onOpen]);

  // if it's no root route, close the modal
  const currentPath = window.location.pathname;
  const isRootRoute = currentPath === "/";
  if (!isRootRoute) {
    return null;
  }

  return (
    <>
      <div className="flex space-x-2 md:hidden p-4 border-b text-sm justify-between bg-white text-background">
        <div className="flex items-center space-x-2">
          <button onClick={() => setShowPWAInstallPrompt(false)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              aria-hidden="true"
              data-slot="icon"
              className="h-4 w-4 flex-none text-gray-500"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18 18 6M6 6l12 12"
              ></path>
            </svg>
          </button>
          <button className="flex items-center space-x-2" onClick={onOpen}>
            <div className="border rounded-lg flex-none">
              <img
                src="/icons/icon.svg"
                alt="ManUp logo"
                className="object-contain h-10 w-10 flex-none rounded-lg"
              />
            </div>
            <div className="flex flex-col text-start">
              <span className="font-bold">ManUp</span>
              <span className="font-light text-xs">Date with confidence</span>
            </div>
          </button>
        </div>
        <button className="flex-none" onClick={onOpen}>
          <span className="flex-none rounded-full px-2 py-1 bg-blue-500 text-white font-bold">
            GET APP
          </span>
        </button>
      </div>
      <Modal
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        scrollBehavior="inside"
      >
        <ModalContent>
          {() => (
            <>
              <ModalHeader className="flex flex-col gap-1">
                Install ManUp in 5 seconds
              </ModalHeader>
              <ModalBody>
                <p className="">
                  No need to download from the App Store. Just follow these
                  simple steps:
                </p>

                {!isSafari && (
                  <>
                    <div className="flex items-center gap-4 p-3">
                      <FaSafari className="text-blue-500 w-8 h-8" />
                      <span>Open this page in Safari</span>
                      <Button
                        onPress={() => {
                          // build query params
                          const url = new URL(window.location.href);
                          url.searchParams.set(
                            Constants.PWA
                              .SHOW_IOS_INSTALL_PROMPT_MODEL_QUERY_PARAM,
                            "true"
                          );
                          navigator.clipboard.writeText(url.toString());
                          setLinkCopied(true);
                        }}
                      >
                        {linkCopied ? "Copied" : "Copy Link"}
                      </Button>
                    </div>
                    <p>
                      Then, follow the instruction to complete installation.
                    </p>
                  </>
                )}

                {isSafari && (
                  <>
                    <div>
                      <div className="flex gap-4 p-3">
                        <GoShare className="text-blue-500 w-10 h-10" />
                        <span>
                          Tap the Share button at the bottom of your screen
                        </span>
                      </div>
                      <Image
                        src="/share-btn.png"
                        alt="Share button"
                        className="mb-2"
                      />
                    </div>

                    <div>
                      <div className="flex gap-4 p-3">
                        <BsPlusSquare className="text-blue-500 w-10 h-10" />
                        <span>
                          Tap the Share button at the bottom of your screen
                        </span>
                      </div>
                      <Image
                        src="/add-to-home-screen-btn.png"
                        alt="Add to home screen"
                      />
                    </div>
                  </>
                )}
              </ModalBody>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};
